import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNft = function SvgNft(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_129_7627",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_129_7627)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1894E8",
        fillOpacity: 0.15,
        d: "M18.347 68.986q1.347 1.347 3.268 1.347h44.103q1.92 0 3.268-1.347t1.347-3.268V21.615q0-1.92-1.347-3.268T65.718 17H21.615q-1.92 0-3.268 1.347T17 21.615v44.103q0 1.92 1.347 3.268"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_129_7627)",
        d: "M61.718 66.334H17.615q-1.92 0-3.268-1.347T13 61.718V17.616q0-1.922 1.347-3.269T17.615 13h44.103q1.92 0 3.268 1.347t1.347 3.269v44.102q0 1.921-1.347 3.269-1.347 1.347-3.268 1.347m-45.513-3.206q.192.193.545.417.352.224.865.224h22.052V36.231l23.461 26.897q.192-.193.417-.544.224-.353.224-.866V17.616q0-.898-.577-1.475-.576-.577-1.474-.577H39.667v20.667z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_129_7627",
        x1: 13.557,
        x2: 65.591,
        y1: 39.666,
        y2: 39.666,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgNft as ReactComponent };
//# sourceMappingURL=NFT.svg.es.js.map
